import { coerceBooleanProperty } from '@angular/cdk/coercion';

import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ServicemeshLoadingService } from '@helpers/services/loading';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'servicemesh-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'servicemeshLoadingBar',
  standalone: true,
  imports: [MatProgressBarModule],
})
export class ServicemeshLoadingBarComponent implements OnChanges, OnInit, OnDestroy {
  private readonly _servicemeshLoadingService = inject(ServicemeshLoadingService);

  @Input() autoMode: boolean = true;
  mode!: 'determinate' | 'indeterminate';
  progress: number = 0;
  show: boolean = false;
  private readonly _unsubscribeAll: Subject<boolean> = new Subject<boolean>();
  private readonly _changeDetectRef = inject(ChangeDetectorRef);

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On changes
   *
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    // Auto mode
    if ('autoMode' in changes) {
      // Set the auto mode in the service
      this._servicemeshLoadingService.setAutoMode(
        coerceBooleanProperty(changes.autoMode.currentValue)
      );
    }
  }

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to the service
    this._servicemeshLoadingService.mode$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        this.mode = value;
      });

    this._servicemeshLoadingService.progress$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        this.progress = value;
      });

    this._servicemeshLoadingService.show$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        this.show = value;
        this._changeDetectRef.detectChanges();
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }
}
